// Landing v2 — Contenido centralizado.
// Todos los textos viven acá. Cambiar copy = editar este archivo.

export const META = {
  brand:      "iDaaS Perú",
  tagline:    "Verificación de identidad para empresas peruanas",
  ctaPrimary: "Verificar un DNI ahora",
  ctaSecondary: "Ver la API",
  ctaRegister: "Crear cuenta gratis",
};

export const HERO = {
  badge: "Plataforma KYC peruana",
  headline: ["Verifica identidades", "en segundos.", "No en días."],
  sub: "Consulta RENIEC, prueba de vida 3D con AWS, comparación facial 1:1 y OCR del DNI. Una sola API, cero fricción.",
  demo: {
    placeholder: "Ingresá un DNI (ej: 70024754)",
    button: "Verificar",
    mockResult: {
      nombres:   "JUAN CARLOS",
      apellidos: "PÉREZ GARCÍA",
      dni:       "70024754",
      estado:    "ACTIVO",
      condicion: "HABIDO",
      score:     "99.2%",
    },
  },
  metrics: [
    { value: "99.7%", label: "Precisión facial" },
    { value: "<3s",   label: "Tiempo promedio" },
    { value: "24/7",  label: "Uptime" },
  ],
};

export const LOGOS = {
  title: "Equipos que confían en iDaaS",
  // Placeholders — reemplazar por logos reales cuando existan
  items: [
    "FINTECH PERÚ", "GRUPO ANDES", "NOTARÍA LIMA",
    "CLÍNICA SAN PABLO", "EDUCA+", "SEGUROS PACÍFICO",
  ],
};

export const HOW = {
  title: "Cómo funciona",
  sub: "Tres pasos. Ninguna integración compleja.",
  steps: [
    {
      n: "01",
      title: "Integrá la API",
      desc:  "Un endpoint POST. Autenticás con API key y mandás el DNI. Listo.",
    },
    {
      n: "02",
      title: "El ciudadano verifica",
      desc:  "Selfie con liveness 3D, comparación facial y OCR del DNI. Todo guiado.",
    },
    {
      n: "03",
      title: "Recibís el resultado",
      desc:  "Certificado firmado con QR verificable. Webhook al instante.",
    },
  ],
};

export const PRODUCT = {
  title: "Un solo producto, tres formas de usarlo",
  tabs: [
    {
      id: "api",
      label: "API REST",
      desc: "Integración directa con tu backend. JSON in, JSON out.",
    },
    {
      id: "dashboard",
      label: "Panel web",
      desc: "Visualizá verificaciones, timeline forense y métricas en tiempo real.",
    },
    {
      id: "widget",
      label: "Widget embebible",
      desc: "Pegá una línea en tu web y dejá que iDaaS haga todo el flujo.",
    },
  ],
};

export const USE_CASES = {
  title: "Casos de uso",
  industries: [
    { id: "all",     label: "Todos" },
    { id: "fintech", label: "Fintech y banca" },
    { id: "rrhh",    label: "RRHH" },
    { id: "salud",   label: "Salud" },
    { id: "legal",   label: "Legal y notarías" },
  ],
  cases: [
    { industry: "fintech", title: "Onboarding digital",   desc: "Alta de clientes 100% remota con KYC regulado." },
    { industry: "fintech", title: "Prevención de fraude", desc: "Detección de suplantación y cuentas duplicadas." },
    { industry: "rrhh",    title: "Contratación remota",  desc: "Validá identidad antes de firmar contrato." },
    { industry: "salud",   title: "Telemedicina",         desc: "Paciente verificado antes de la consulta." },
    { industry: "legal",   title: "Firma de documentos",  desc: "Fe pública del firmante con certificado." },
    { industry: "legal",   title: "Poderes notariales",   desc: "Verificación de identidad para actos notariales." },
  ],
};

export const PRICING = {
  title: "Precios simples, saldo que no vence",
  sub: "Sin cargos mensuales. Pagás por uso, recargás cuando quieras.",
  // Reutilizamos los 5 planes existentes (plan_service.py) en soles.
  tiers: [
    { id: "p20",   label: "Starter",    price: 20,   soles: "73.50",    popular: false },
    { id: "p100",  label: "Growth",     price: 100,  soles: "367.50",   popular: false },
    { id: "p500",  label: "Business",   price: 500,  soles: "1,837.50", popular: true  },
    { id: "p1000", label: "Pro",        price: 1000, soles: "3,675.00", popular: false },
    { id: "p5000", label: "Enterprise", price: 5000, soles: "18,375.00",popular: false },
  ],
  note: "5% extra en transferencias. Saldo en soles, sin vencimiento.",
};

export const TRUST = {
  title: "Confianza operativa",
  items: [
    { title: "SUNAT verificado",  desc: "RUC activo y habido — exigido a todos los clientes." },
    { title: "Encriptación AES-256", desc: "Datos biométricos cifrados en reposo y tránsito." },
    { title: "Auditoría forense", desc: "Cada paso del ciudadano queda registrado con timestamp UTC." },
    { title: "Uptime 99.9%",      desc: "Infraestructura en AWS con alarmas y monitoreo continuo." },
  ],
};

export const FAQ = {
  title: "Preguntas frecuentes",
  items: [
    { q: "¿Cómo obtengo saldo?",        a: "Registrándote gratis obtenés S/10 de bono de bienvenida. Después recargás cuando quieras." },
    { q: "¿Qué pasa si un DNI no existe?",   a: "El flujo devuelve NOT_FOUND sin consumir saldo de verificación facial." },
    { q: "¿Guardan las fotos de los DNI?",   a: "Sí, cifradas, para auditoría forense. Cumplimos con la Ley 29733." },
    { q: "¿Puedo probar antes de pagar?",    a: "Sí. Al registrarte te damos S/10 de bono gratis." },
    { q: "¿Tienen SDK oficial?",             a: "API REST estándar. SDKs en roadmap (Node, Python, PHP)." },
    { q: "¿Cómo integro el flujo hosted?",   a: "Creás un flow en el panel, copiás el link y lo compartís. Sin código." },
  ],
};

export const CTA_FINAL = {
  title: "Empezá a verificar identidades hoy",
  sub: "Creá tu cuenta gratis, recibí S/10 de bono de bienvenida y hacé tu primera verificación en menos de 5 minutos.",
  bullets: ["Sin tarjeta de crédito", "Bono de bienvenida", "Soporte en español"],
};

export const FOOTER = {
  columns: [
    {
      title: "Producto",
      links: [
        { label: "Precios",     to: "/precios" },
        { label: "API Docs",    to: "/api-docs" },
        { label: "Estado",      to: "/status" },
      ],
    },
    {
      title: "Empresa",
      links: [
        { label: "Términos",    to: "/terminos" },
        { label: "Privacidad",  to: "/privacidad" },
        { label: "Soporte",     href: "mailto:soporte@idaas.lat" },
      ],
    },
  ],
};
